import React, { useState } from 'react';
import { Box, Typography, IconButton, Tooltip, Paper } from '@mui/material';
import { BsTicketDetailed as TicketIcon } from 'react-icons/bs';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import TicketView from '@IssueConsoleViews/TicketView';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import './KzqTicketRegistryItem.scss';

const PRIORITY_CONFIG = {
    critical: { label: 'Critical', color: '#c62828', bg: 'rgba(198,40,40,0.1)', border: 'rgba(198,40,40,0.3)' },
    high:     { label: 'High',     color: '#e64a19', bg: 'rgba(230,74,25,0.1)',  border: 'rgba(230,74,25,0.3)' },
    medium:   { label: 'Medium',   color: '#ef6c00', bg: 'rgba(239,108,0,0.1)',  border: 'rgba(239,108,0,0.3)' },
    low:      { label: 'Low',      color: '#2e7d32', bg: 'rgba(46,125,50,0.1)',  border: 'rgba(46,125,50,0.3)' },
};

const getPriorityConfig = (priority) => {
    if (!priority) return null;
    return PRIORITY_CONFIG[priority.toLowerCase()] || { label: priority, color: '#616161', bg: 'rgba(97,97,97,0.1)', border: 'rgba(97,97,97,0.3)' };
};

const formatDate = (ts) => {
    if (!ts) return '—';
    const d = new Date(ts);
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export default function KzqTicketRegistryItem({ item, onStatusClick }) {
    const [showTicketView, setShowTicketView] = useState(false);
    const { activeUserId } = useReduxActiveUser();
    const cn = 'kzqTicketRegistryItem';

    const priorityCfg = getPriorityConfig(item?.priority);

    const statusBg   = item?.statusColor ? `${item.statusColor}18` : 'rgba(97,97,97,0.08)';
    const statusBorder = item?.statusColor ? `${item.statusColor}40` : 'rgba(97,97,97,0.2)';
    const statusColor  = item?.statusColor || '#616161';

    const handleStatusClick = (e) => {
        e.stopPropagation();
        if (onStatusClick && item?.statusId != null) {
            onStatusClick({ id: item.statusId, label: item.statusLabel, color: item.statusColor });
        }
    };

    return (
        <>
            <Paper className={cn} elevation={0} onClick={() => setShowTicketView(true)}>
                <Box className={`${cn}__row`}>

                    {/* Ticket ID */}
                    <Box className={`${cn}__idSection`}>
                        <Box className={`${cn}__typeIcon`}>
                            <TicketIcon />
                        </Box>
                        <span className={`${cn}__ticketId`}>{item?.ticketId || '—'}</span>
                    </Box>

                    {/* Title */}
                    <Box className={`${cn}__titleSection`}>
                        <Typography className={`${cn}__title`} noWrap>
                            {item?.ticketTitle || <span className={`${cn}__title--empty`}>No title</span>}
                        </Typography>
                    </Box>

                    {/* Status */}
                    <Tooltip title={`Filter by: ${item?.statusLabel}`}>
                        <button
                            className={`${cn}__statusBadge`}
                            style={{ color: statusColor, background: statusBg, borderColor: statusBorder }}
                            onClick={handleStatusClick}
                        >
                            <span className={`${cn}__statusDot`} style={{ background: statusColor }} />
                            {item?.statusLabel || 'Unknown'}
                        </button>
                    </Tooltip>

                    {/* Priority */}
                    {priorityCfg && (
                        <span
                            className={`${cn}__priorityPill`}
                            style={{ color: priorityCfg.color, background: priorityCfg.bg, borderColor: priorityCfg.border }}
                        >
                            {priorityCfg.label}
                        </span>
                    )}

                    {/* Submitter */}
                    {item?.createdByFullName && (
                        <Box className={`${cn}__submitter`}>
                            <PersonOutlineIcon className={`${cn}__submitter__icon`} />
                            <Typography className={`${cn}__submitter__name`} noWrap>
                                {item.createdByFullName}
                            </Typography>
                        </Box>
                    )}

                    {/* Date */}
                    <Typography className={`${cn}__date`}>
                        {formatDate(item?.registryCreateTimeStamp)}
                    </Typography>

                    {/* Action */}
                    <Box className={`${cn}__action`}>
                        <Tooltip title="Open ticket">
                            <IconButton size="small" className={`${cn}__openBtn`} onClick={(e) => { e.stopPropagation(); setShowTicketView(true); }}>
                                <OpenInNewIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </Paper>

            {showTicketView && (
                <TicketView
                    open={showTicketView}
                    closePopup={() => setShowTicketView(false)}
                    profileId={activeUserId}
                    ticketId={item?.targetId}
                    reloadData={() => {}}
                />
            )}
        </>
    );
}
